module.exports = {"532527101":"中枢镇","532527102":"金马镇","532527104":"旧城镇","532527106":"午街铺镇","532527107":"白水镇","532527201":"向阳乡","532527202":"三塘乡","532527203":"永宁乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532527.json
// module id = 2440
// module chunks = 0